import { normalizeTrackerStatusKey } from './trackerNormalization';

const LOCKED_TRACKER_STATUSES = new Set([
    'delayed',
    'delayed-compliance',
    'delayed-complied',
    'complied',
    'complied-on-time',
    'not-applicable',
]);

export const normalizeRole = (role = '') =>
    String(role || '')
        .trim()
        .toLowerCase()
        .replace(/[\s_-]+/g, '');

export const normalizeTrackerStatus = normalizeTrackerStatusKey;

export const isAdminRole = (role = '') => normalizeRole(role) === 'admin';

export const isLockedTrackerStatus = (status = '') =>
    LOCKED_TRACKER_STATUSES.has(normalizeTrackerStatus(status));

export const TRACKER_LOCK_UI_MESSAGE =
    'This tracker is locked (Delayed, Complied, or NA). Only admins can modify it.';
